module.exports = __webpack_public_path__ + "static/the-largesse-of-the-sea-maiden-a5e595d5f122c267d966438845bbb979.jpg";